(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('styledDatepicker', {
            templateUrl: 'app/components/styled-datepicker/styled-datepicker.html',
            controller: styledDatepickerController,
            bindings: {
                labelKey: '@',
                model: '=',
                name: '@',
                required: '<',
                form: '<',
                disabled: '<'
            }
        });

    /** @ngInject */
    function styledDatepickerController() {
    }
})();
